import { LegalPage, PRIVACY } from "@agent-todo/shared-ui"
import { createFileRoute } from "@tanstack/react-router"

import { Navbar } from "@/components/Navbar"

export const Route = createFileRoute("/privacy")({
  component: () => (
    <>
      <Navbar />
      <LegalPage doc={PRIVACY} />
    </>
  ),
})
